import React from "react";

const CrownSvg = ({ fill = "#B0B3C7", width = "14px", height = "14px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_938_17157)">
        <path
          d="M13.2802 2.66353C13.067 2.57474 12.8322 2.5514 12.6058 2.59649C12.3793 2.64157 12.1714 2.75304 12.0085 2.9167L10.5 4.4252L7.82483 1.75003C7.60605 1.53132 7.30936 1.40845 7 1.40845C6.69064 1.40845 6.39395 1.53132 6.17517 1.75003L3.5 4.4252L1.9915 2.9167C1.82834 2.75359 1.62048 2.64251 1.3942 2.59752C1.16793 2.55252 0.933386 2.57563 0.720236 2.66391C0.507087 2.75219 0.324896 2.90168 0.196698 3.0935C0.0684998 3.28531 4.92617e-05 3.51082 0 3.74153L0 9.9167C0.00092625 10.69 0.308514 11.4313 0.855295 11.9781C1.40208 12.5249 2.1434 12.8324 2.91667 12.8334H11.0833C11.8566 12.8324 12.5979 12.5249 13.1447 11.9781C13.6915 11.4313 13.9991 10.69 14 9.9167V3.74153C14.0001 3.5108 13.9317 3.28524 13.8036 3.09336C13.6754 2.90148 13.4933 2.7519 13.2802 2.66353Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_938_17157">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CrownSvg;
